import React, { FC, memo, useCallback } from 'react';

import WalletIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';

import { useAuth } from '@contexts/common/AuthorizationContext';
import { modalActions } from '@contexts/common/ModalContext';

import Button from '@components/common/Button';
import ChainButton from '@components/common/ChainButton';
import ConnectWalletButton from '@components/common/ConnectWalletButton';

import { IDs } from '@constants/common/ids.constants';
import { MODAL_TYPES } from '@constants/common/modals.constants';
import { Size, Variant } from '@constants/common/ui.constants';

import useStyles from './styles.module';

interface Props {
  onOpen?: () => void;
  onClose: () => void;
  isOpen?: boolean;
}

const HeaderButtons: FC<Props> = ({
  onClose,
  onOpen,
  isOpen = true,
}: Props) => {
  const { classes } = useStyles();
  const { account } = useAuth();

  const handleUserWallet = useCallback(() => {
    modalActions.show(MODAL_TYPES.ACCOUNT_MODAL);
  }, []);

  const handleChain = useCallback(() => {
    if (onClose) {
      onClose();
    }
    modalActions.show(MODAL_TYPES.CHAIN_MODAL);
  }, [onClose]);

  return (
    <div className={classes.buttons}>
      <ChainButton
        className={classes.chainButton}
        onClick={handleChain}
        size={Size.Large}
      />
      {account ? (
        <Button
          onClick={handleUserWallet}
          variant={Variant.Secondary}
          className={classes.walletButton}
          id={IDs.HEADER_OPEN_WALLET_MODAL_BUTTON}
        >
          <WalletIcon />
        </Button>
      ) : (
        <ConnectWalletButton
          onClose={onClose}
          withIcon
          variant={Variant.Secondary}
          className={classes.connectWallet}
          id={IDs.HEADER_CONNECT_WALLET_BUTTON}
        />
      )}
      <Button
        aria-label="close drawer"
        onClick={isOpen ? onClose : onOpen}
        variant={Variant.Secondary}
        className={classes.closeIcon}
      >
        {isOpen ? <CloseIcon /> : <MenuIcon />}
      </Button>
    </div>
  );
};

export default memo(HeaderButtons);
